import { Box, Button, Grid, Input, Label } from 'TBM/OldSharedUI';
import { useLoop } from 'loop/context';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useForm } from 'react-hook-form';

type FormData = {
  email: string;
};

export function ForgotPasswordForm() {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<FormData>();
  const { client } = useLoop();
  const router = useRouter();

  const onSubmit = handleSubmit(async (formData) => {
    return client
      .forgotPassword(formData.email)
      .then(() => {
        router.replace({
          query: { ...router.query, isOtp: 1, email: formData.email },
        });
      })
      .catch(() => alert('Error confirming signup'));
  });

  return (
    <form onSubmit={onSubmit}>
      <Grid gridGap={6} mt={6} mb={6}>
        <Box>
          <Label mb={3}>Email</Label>
          <Input type="text" readOnly={false} {...register('email')} />
        </Box>
        <Button type="submit" variant="accent" disabled={isSubmitting}>
          {router.locale?.startsWith('it') ? 'Invia Email' : 'Send Email'}
        </Button>
      </Grid>
      <Link href="/v2/signin" passHref>
        <Box as="a" fontSize={1}>
          {router.locale?.startsWith('it')
            ? 'Torna al Login'
            : 'Back to Signin'}
        </Box>
      </Link>
    </form>
  );
}
